import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

export const exhibitionseventsroutes: Routes = [

  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
    data: { animation: 'events' },
    canActivate: [AuthGuard]
  },
  {
    path: 'materials',
    loadChildren: () => import('./materials/materials.module').then(m => m.MaterialsModule),
    data: { animation: 'materials' },
    canActivate: [AuthGuard]
  },
  {
    path: 'fairs',
    loadChildren: () => import('./feria/feria.module').then(m => m.FeriaModule),
    data: { animation: 'feria' },
    canActivate: [AuthGuard]
  }
]
